import { History } from 'history';
import { AdvertStore } from './AdvertStore';
import { AuthStore } from './AuthStore';
import { CategoryStore } from './CategoryStore';
import { NavMenuStore } from './NavMenuStore';
import { NotificationStore } from './NotificationStore';
import { RouterStore } from './RouterStore';
import { SubscriptionStore } from './SubscriptionStore';
import { SubscriptionPlanStore } from './SubscriptionPlanStore';
import { TagStore } from './TagStore';
import { VideoStore } from './VideoStore';
import {
  STORE_ADVERT,
  STORE_AUTH,
  STORE_CATEGORY,
  STORE_NAV_MENU,
  STORE_NOTIFICATION,
  STORE_ROUTER,
  STORE_SUBSCRIPTION,
  STORE_SUBSCRIPTION_PLAN,
  STORE_TAG,
  STORE_VIDEO
} from '../constants';

export function createStores(history: History) {
  const categoryStore = new CategoryStore();
  const authStore = new AuthStore();
  const videoStore = new VideoStore(categoryStore, authStore);
  const routerStore = new RouterStore(history);
  const subscriptionStore = new SubscriptionStore(routerStore, authStore);

  return {
    [STORE_ADVERT]: new AdvertStore(),
    [STORE_AUTH]: authStore,
    [STORE_CATEGORY]: categoryStore,
    [STORE_NAV_MENU]: new NavMenuStore(
      categoryStore,
      authStore,
      subscriptionStore
    ),
    [STORE_NOTIFICATION]: new NotificationStore(),
    [STORE_ROUTER]: routerStore,
    [STORE_SUBSCRIPTION]: subscriptionStore,
    [STORE_SUBSCRIPTION_PLAN]: new SubscriptionPlanStore(),
    [STORE_TAG]: new TagStore(),
    [STORE_VIDEO]: videoStore
  };
}



// WEBPACK FOOTER //
// ./src/app/stores/createStore.ts